var render, staticRenderFns
import script from "./PieGraph.vue?vue&type=script&lang=js&"
export * from "./PieGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8655ff28')) {
      api.createRecord('8655ff28', component.options)
    } else {
      api.reload('8655ff28', component.options)
    }
    
  }
}
component.options.__file = "src/components/stats/charts/PieGraph.vue"
export default component.exports